import * as React from 'react';
import { isMobileOrTabletWindow } from '~/utils/utils';

interface IPurchaseCustomizationWrapper {
    category: ICategory;
    bundle: IBundle;
    children: React.ReactNode;
}

const PurchaseCustomizationWrapper = ({ category, bundle, children }: IPurchaseCustomizationWrapper) => {
    const fallback = <>{children}</>;

    if (isMobileOrTabletWindow || !category) {
        return fallback;
    }

    switch (category.theme) {
        default: {
            return fallback;
        }
    }
};

export default PurchaseCustomizationWrapper;
